import { hostname } from '@haaretz/s-consts';

import cookieToMap from '../cookieToMap';

export default function setCookie(cookieName: string, value: string, expires: Date) {
  document.cookie = `${cookieName}=${value}; path=/; domain=.${hostname}; expires=${expires};`;

  return cookieToMap(document.cookie, true)[cookieName] as string;
}
